export default "__VITE_ASSET__CPed3uMh__"